/**
 * Cross-origin URL helpers for the marketing/app domain split.
 *
 * In production the two surfaces live on different origins
 * (marketing = https://write4me.co, app = https://app.write4me.co), so links
 * that cross from one to the other must be ABSOLUTE. Locally (and on previews)
 * the env vars are unset and these helpers return RELATIVE paths, so a single
 * origin behaves exactly as before the split — fully backward compatible.
 *
 * Reads `process.env.NEXT_PUBLIC_*` directly so Next inlines the value at build
 * time for both server and client bundles.
 */

function buildUrl(base: string | undefined, path: string): string {
  const trimmed = base?.replace(/\/+$/, '') ?? '';
  if (!trimmed) {
    // No configured origin → relative path (local dev / single origin).
    return path;
  }
  return `${trimmed}${path.startsWith('/') ? path : `/${path}`}`;
}

/** Absolute URL into the web app (app.write4me.co) when configured, else relative. */
export function appUrl(path = '/'): string {
  return buildUrl(process.env.NEXT_PUBLIC_APP_URL, path);
}

/** Absolute URL into the marketing site (write4me.co) when configured, else relative. */
export function marketingUrl(path = '/'): string {
  return buildUrl(process.env.NEXT_PUBLIC_MARKETING_URL, path);
}
